module.exports = __webpack_public_path__ + "img/vitamin-1.ec8bbaf8.png";